import { render, staticRenderFns } from "./addPic.vue?vue&type=template&id=197dba10&scoped=true&"
import script from "./addPic.vue?vue&type=script&lang=js&"
export * from "./addPic.vue?vue&type=script&lang=js&"
import style0 from "./addPic.vue?vue&type=style&index=0&id=197dba10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197dba10",
  null
  
)

export default component.exports